var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appt-detail-pdf"},[_c('ApptDetailPDF',{attrs:{"appt":_vm.appt}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }